import styles from './style.module.scss';
import {ReactComponent as AskLioIcon} from '../../assests/svg/askLioDrawerHeaderButtonIcon.svg';
import {useDispatch, useSelector} from 'react-redux';
import {setIsChatPanelVisible} from '../../redux/slices/askLioSlice';
import AurButton from '../common/aur-button/AurButton';
import {RootState} from '../../redux/store';
import {t} from 'i18next';

const AurAskLioDrawerHeaderButton: React.FC = () => {
  const dispatch = useDispatch();
  const isLioOpen = useSelector(
    (state: RootState) => state.askLioSlice.isChatPanelVisible
  );

  const handleButtonClick = () => {
    dispatch(setIsChatPanelVisible(!isLioOpen));
  };

  return (
    <>
      {!isLioOpen && (
        <AurButton
          classNames={`${styles.aurDrawerHeaderAskLioButton}`}
          ariaLabel={t('askLio.askLioAriaLabel')}
          type="exit"
          label={t('askLio.askLioHeader')}
          startIcon={<AskLioIcon aria-hidden="true" />}
          size="Medium"
          onClick={handleButtonClick}
          dataTestId='ask-lio-header'
        />
      )}
    </>
  );
};

export default AurAskLioDrawerHeaderButton;
